import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Table } from "tabler-react";
import { toast } from "react-toastify";
import moment from "moment";

const WaitlistEntryRow = ({
    t,
    entry,
    onPromote,
    onRemove,
    isLoading = false,
    canManageWaitlist = true,
}) => {
    const {
        account,
        waitlistPosition,
        joinedWaitlistAt,
        attendanceType,
        accountClasspass,
        accountSubscription,
        canCancelWaitlist,
        canPromoteFromWaitlist,
    } = entry;

    const handlePromote = async () => {
        if (!canPromoteFromWaitlist) {
            toast.warning(t("schedule.classes.waitlist.cannot_promote"));
            return;
        }

        try {
            await onPromote(entry.id);
            toast.success(t("schedule.classes.waitlist.promote_success"));
        } catch (error) {
            toast.error(t("schedule.classes.waitlist.promote_error"));
            console.error("Error promoting from waitlist:", error);
        }
    };

    const handleRemove = async () => {
        if (!canCancelWaitlist) {
            toast.warning(t("schedule.classes.waitlist.cannot_cancel"));
            return;
        }

        try {
            await onRemove(entry.id);
            toast.success(t("schedule.classes.waitlist.cancel_success"));
        } catch (error) {
            toast.error(t("schedule.classes.waitlist.cancel_error"));
            console.error("Error cancelling waitlist:", error);
        }
    };

    const getAttendanceTypeDisplay = () => {
        switch (attendanceType) {
            case "CLASSPASS":
                return (
                    accountClasspass?.organizationClasspass?.name ||
                    t("general.classpass")
                );
            case "SUBSCRIPTION":
                return (
                    accountSubscription?.organizationSubscription?.name ||
                    t("general.subscription")
                );
            case "DROPIN":
                return t("general.dropin");
            case "TRIAL":
                return t("general.trial");
            default:
                return attendanceType;
        }
    };

    return (
        <Table.Row>
            <Table.Col>
                <div className="d-flex align-items-center">
                    <span className="badge badge-secondary me-2">
                        #{waitlistPosition}
                    </span>
                    <div>
                        <strong>{account.fullName}</strong>
                        <div className="text-muted small">{account.email}</div>
                    </div>
                </div>
            </Table.Col>
            <Table.Col>{getAttendanceTypeDisplay()}</Table.Col>
            <Table.Col>
                <div className="text-muted small">
                    {moment(joinedWaitlistAt).format("YYYY-MM-DD HH:mm")}
                </div>
            </Table.Col>
            <Table.Col>
                <div className="text-muted small">
                    {moment(joinedWaitlistAt).fromNow()}
                </div>
            </Table.Col>
            <Table.Col>
                {canManageWaitlist && (
                    <div className="d-flex gap-2">
                        <Button
                            color="primary"
                            size="sm"
                            onClick={handlePromote}
                            disabled={isLoading || !canPromoteFromWaitlist}
                            title={
                                canPromoteFromWaitlist
                                    ? t(
                                          "schedule.classes.waitlist.promote_tooltip",
                                      )
                                    : t(
                                          "schedule.classes.waitlist.cannot_promote",
                                      )
                            }
                        >
                            {t("schedule.classes.waitlist.promote")}
                        </Button>
                        <Button
                            color="danger"
                            size="sm"
                            onClick={handleRemove}
                            disabled={isLoading || !canCancelWaitlist}
                            title={
                                canCancelWaitlist
                                    ? t(
                                          "schedule.classes.waitlist.remove_tooltip",
                                      )
                                    : t(
                                          "schedule.classes.waitlist.cannot_cancel",
                                      )
                            }
                        >
                            {t("schedule.classes.waitlist.remove")}
                        </Button>
                    </div>
                )}
            </Table.Col>
        </Table.Row>
    );
};

export default withTranslation()(WaitlistEntryRow);
